import { t, Trans } from '@lingui/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const ShareRegister = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={t`Share registry`}
      documentType="share registry"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        <Trans>Please upload your share register extract.</Trans>
      </p>
    </DocumentRequirement>
  );
};
